module.exports = __webpack_public_path__ + "667dd5ef164d4f6cc3fbc38fdb07b2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/2.50ct.png
// module id = 812
// module chunks = 0